import React, { useState } from 'react';

import { ShowContextProvider } from './ShowContext';
import { Loading, SmallLoader } from 'framework/ui/mui-builder';
import { ResourceData } from 'framework/crud';
import ShowData from './ShowData';
import { ShowDataInstance } from './ShowTypes';
import useGetData from 'framework/utils/hooks/useGetData/useGetData';

interface ShowProps {
  children: React.ReactNode | React.ReactElement;
  getDataMethod: () => Promise<ResourceData>;
  isSmallLoader?: boolean;
}

const Show = ({ children, getDataMethod, isSmallLoader }: ShowProps) => {
  const [data, setDataBase] = useState<ShowDataInstance>(null);
  const setData = (dataObject: object) => setDataBase(new ShowData(dataObject));
  const { loading } = useGetData(getDataMethod, setData);

  if (loading) {
    return isSmallLoader ? <SmallLoader /> : <Loading />;
  }

  return (
    <ShowContextProvider
      value={{
        data,
        setData,
      }}
    >
      {children}
    </ShowContextProvider>
  );
};

export default Show;
